<template>
  <div>
    <div v-if="showAboutModal">
      <modal-about />
    </div>

    <div v-if="showConfigModal">
      <modal-config />
    </div>

    <div v-if="this.showEditModal && this.appConfig !== undefined">
      <modal-edit />
    </div>

    <!-- <modal-report-problem :show="this.showModalReportProblem" /> -->
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import ModalAbout from "./about/ModalAbout.vue";
import ModalConfig from "./config/ModalConfig.vue";
import ModalEdit from "./edit/ModalEdit.vue";
import ModalReportProblem from "./report-problem/ModalReportProblem.vue";

const { mapState, mapActions } = createNamespacedHelpers(
  "integrations/integrationsHome"
);

export default {
  name: "iplink-modal",

  computed: {
    ...mapState(["showAboutModal", "showConfigModal", "showEditModal", "appConfig"]),
  },

  components: {
    ModalAbout,
    ModalConfig,
    ModalEdit,
    ModalReportProblem,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";


</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/modal/Modal.vue